import React from 'react';
import { Track, urlCatalog } from 'angieslist-app-platform';
import logo from './AngiAdsBusinessCenter.png';
import './unauthHeaderConfig.scss';

const headerPlainTextStyle = { margin: '0 10px' };

export default () => ({
  logo,
  homeLink: '/',
  rightNavItems: [
    (<small className="header-right-nav-item" key="unauth-header-right-nav--contact-phone"><span style={headerPlainTextStyle}>{urlCatalog.global.businessCenterPhoneWithLetters()}</span><span className="hidden-xs"> | </span></small>),
    (<small className="header-right-nav-item" key="unauth-header-right-nav--visit-angieslist"><Track><a id="unauth-header-right-nav--angieslist-link" data-track-description="Visit Member Site" href={urlCatalog.global.angiesListHome()}>Visit Angi.com</a></Track></small>),
  ],
  sideBarMenu: [
    (<span key="side-bar--contact-phone"><Track><a id="unauth-side-bar--contact-phone-link" data-track-description="Call AL" href={urlCatalog.global.businessCenterPhone()}>{urlCatalog.global.businessCenterPhoneWithLetters()}</a></Track></span>),
    (<span key="side-bar--visit-angieslist"><Track><a id="unauth-side-bar--angieslist-link" data-track-description="Visit Member Site" href={urlCatalog.global.angiesListHome()}>Visit Angi.com</a></Track></span>),
  ],
});



// WEBPACK FOOTER //
// ./src/app/browser/header/unauthHeaderConfig.js